/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { contactSchema } from './contact-schema';
import { tagSchema } from './tag-schema';
import { userSchema } from './user-schema';
import { AccountType, CountryCode, Industry, PreferredVideoClient } from "../enums";

export const accountSchema: z.AnyZodObject = z.object({
  accountType: z.nativeEnum(AccountType).nullish(),
  blockSelfServicePricing: z.boolean(),
  businessTeam: z.string().nullish(),
  candidates: z.array(z.lazy(() => candidateSchema)).nullish(),
  companyDescription: z.string().nullish(),
  confidentialAccountName: z.string().nullish(),
  contacts: z.array(z.lazy(() => contactSchema)).nullish(),
  createdAt: z.string().datetime().nullish(),
  currency: z.string().nullish(),
  cxPartner: z.lazy(() => userSchema).nullish(),
  cxPartnerId: z.string().uuid().nullish(),
  deletedAt: z.string().datetime().nullish(),
  denied: z.boolean(),
  displayName: z.string().nullish(),
  emailsOptedOut: z.array(z.string()).nullish(),
  fuzzyName: z.string().nullish(),
  hqAddressCountry: z.nativeEnum(CountryCode).nullish(),
  hqAddressState: z.string().nullish(),
  id: z.string().uuid(),
  industryValue: z.nativeEnum(Industry).nullish(),
  integrationId: z.string().nullish(),
  isAccountConfidential: z.boolean().nullish(),
  lawyerOnStaff: z.boolean(),
  name: z.string().nullish(),
  normalizedDomain: z.string().nullish(),
  normalizedName: z.string().nullish(),
  ownerUser: z.lazy(() => userSchema).nullish(),
  ownerUserId: z.string().uuid().nullish(),
  ownerUserRole: z.string().nullish(),
  parentAccount: z.lazy(() => accountSchema).nullish(),
  parentAccountId: z.string().uuid().nullish(),
  preferredVideoClient: z.nativeEnum(PreferredVideoClient).nullish(),
  reassignedAt: z.string().datetime().nullish(),
  reassignedToAccount: z.lazy(() => accountSchema).nullish(),
  reassignedToAccountId: z.string().uuid().nullish(),
  region: z.nativeEnum(CountryCode).nullish(),
  salesforceId: z.string().nullish(),
  selfServiceEligible: z.boolean(),
  subIndustry: z.lazy(() => tagSchema).nullish(),
  subIndustryId: z.string().uuid().nullish(),
  updatedAt: z.string().datetime().nullish(),
  website: z.string().nullish(),
  zoomIndustry: z.string().nullish(),
  zoomRecordId: z.string().nullish(),
});

export type Account = z.infer<typeof accountSchema>;
